export default __webpack_public_path__ + "static/media/planet.28dc81e1.webp";